<template>
  <div class="gmap-autocomplete">
    <div v-if="hideDefaultInput" ref="input">
      <slot
              name="input"
              v-bind="{$attrs, $listeners}"
      ></slot>
    </div>
    <input
            class="default-input"
            v-else
            ref="input"
            v-bind="$attrs"
            v-on="$listeners"
            :placeholder="placeholder"
    />
  </div>
</template>

<script>
export default (function (x) { return x.default || x })(require('./autocompleteImpl.js'))
</script>

<style scoped>
  .gmap-autocomplete .default-input{
    flex-grow: 1;
  }
</style>
